import config from './config.json';

export const getApiConfig = () => {
  return config.deploymentEnv === 'prod'
    ? config.production
    : config.development;
};
